module.exports = __webpack_public_path__ + "static/media/Regulator Knob.06248fde.svg";